import { ThemeConfig } from '@ahha/theme/CampTheme'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type ConfigType = {
  currentLanguage: string,
  currentTheme: string,
  creditDisabled: boolean,
}

const initialState = {
  currentLanguage: 'ko',
  currentTheme: '',
  creditDisabled: true,
}

export const config = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setCurrentLanguage(state, action: PayloadAction<string>) {
      return {
        ...state,
        currentLanguage: action.payload,
      }
    },
    setCurrentTheme(state, action: PayloadAction<string>) {
      return {
        ...state,
        currentTheme: action.payload,
      }
    },
    setCreditDisabled(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        creditDisabled: action.payload,
      }
    },
  },
})

export const { setCurrentLanguage, setCurrentTheme, setCreditDisabled } = config.actions
export default config.reducer
